import React, { forwardRef, ForwardedRef, SelectHTMLAttributes } from "react";
import classNames from "classnames";
import { SelectProps } from "./types";

const Select = forwardRef(
  (
    { children, className, invalid = false, size = "md", ...rest }: SelectProps,
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    const selectClassNames = classNames(
      "rds-Select",
      {
        [`rds-Select--${size}`]: size !== "md",
        "is-invalid": invalid,
      },
      className
    );

    const conditionalAttributes: SelectHTMLAttributes<HTMLSelectElement> = {
      "aria-invalid": invalid || undefined,
    };

    return (
      <select
        className={selectClassNames}
        ref={ref}
        {...conditionalAttributes}
        {...rest}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = "Select";

export default Select;
